import React, { Component } from 'react'
import styled from 'styled-components'
import Row from '../components/Row'
import Text from '../components/Text'

const Image = styled.img`
  display: block;
  margin: 0 0.5rem;
  @media (min-width: 500px) {
    margin: 0 0.25rem;
  }
  @media (min-width: 830px) {
    margin: 0.25rem .5rem;
  }
`

const Eye = styled.i.attrs({ className: "fas fa-eye" })`
  color: ${props => props.active ? '#000' : 'var(--light-gray)'};
  font-size: .8rem;
  margin: 0;
  @media (min-width: 500px) {
    font-size: 1rem;
  }
  @media (min-width: 830px) {
    font-size: 1.2rem;
    margin: 0 0.15rem;
  }
`

const MedicationLabel = styled.div`
  font-size: 1.2rem;
  font-weight: 300;
`

const Frequency = styled.div`
  font-size: 0.9rem;
  color: var(--dark-gray);
  margin-top: 0.5rem;
`

const Col = styled.div`
  flex-direction: column;
  padding-right: .25rem;
`

export default class MedicationDisplay extends Component {
  render() {
    const { medication } = this.props

    return (
      <Row alignCenter>
        <Col>
          <Image alt="" src={`/images/medications/${medication.prescription}.png`} />
          <Eye active={medication.eye === 'LEFT' || medication.eye === 'BOTH'} />
          <Eye active={medication.eye === 'RIGHT' || medication.eye === 'BOTH'} />
        </Col>
        <Row.Cell>
          <MedicationLabel>
            <Text str={`choices.medication.${medication.prescription}`} />
          </MedicationLabel>
            <Frequency>
              <Text str={`choices.eye.${medication.eye}`} />
              {', '}{!medication.frequency ? `1` : medication.frequency}
              <Text str="titles.frequency" />
            </Frequency>
        </Row.Cell>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MedicationDisplay.js